import { InjectionToken } from "@angular/core";
import { HttpInterceptor, HttpContextToken } from "@angular/common/http";

/**
 * Injection token for the dcs client base API path
 */
export const BASE_PATH_DCS = new InjectionToken<string>('BASE_PATH_DCS', {
    providedIn: 'root',
    factory: () => '/api', // Default fallback
});
/**
 * Injection token for the dcs client HTTP interceptor instances
 */
export const HTTP_INTERCEPTORS_DCS = new InjectionToken<HttpInterceptor[]>('HTTP_INTERCEPTORS_DCS', {
    providedIn: 'root',
    factory: () => [], // Default empty array
});
/**
 * HttpContext token to identify requests belonging to the dcs client
 */
export const CLIENT_CONTEXT_TOKEN_DCS = new HttpContextToken<string>(() => 'dcs');
